/** The sidebar draws before this module's chunk loads, so its labels are registered up front (see messages.nav.ts). */
export const expensesNavEn = {
  "exp.nav.entries": "Expenses",
  "exp.nav.vendors": "Vendors",
  "exp.nav.reports": "Finance reports",
} as const;

export const expensesEn = {
  ...expensesNavEn,
  "exp.tabs.label": "Expense sections",
  "exp.tabs.entries": "Expenses and bills",
  "exp.tabs.vendors": "Vendors",
  "exp.tabs.categories": "Categories",
  "exp.tabs.income": "Other income",

  "exp.entries.title": "Expenses and vendor bills",
  "exp.entries.subtitle": "What the club spends: paid expenses and the bills vendors send, newest first.",
  "exp.entries.addExpense": "Add expense",
  "exp.entries.addBill": "Add vendor bill",
  "exp.entries.empty": "No expenses yet",
  "exp.entries.emptyBody": "Record an expense that is already paid, or a vendor bill to pay later.",
  "exp.entries.noMatch": "Nothing matches these filters",
  "exp.entries.noMatchBody": "Widen the dates or clear a filter.",
  "exp.entries.open": "Open {description}",

  "exp.filter.search": "Search",
  "exp.filter.searchHint": "Description, bill number or vendor",
  "exp.filter.kind": "Type",
  "exp.filter.status": "Status",
  "exp.filter.vendor": "Vendor",
  "exp.filter.department": "Department",
  "exp.filter.category": "Category",
  "exp.filter.from": "From",
  "exp.filter.to": "To",
  "exp.filter.clear": "Clear filters",
  "exp.filter.anyVendor": "Any vendor",
  "exp.filter.anyDepartment": "Any department",
  "exp.filter.anyCategory": "Any category",

  "exp.kind.expense": "Expense",
  "exp.kind.bill": "Vendor bill",
  "exp.status.unpaid": "Unpaid",
  "exp.status.paid": "Paid",
  "exp.status.void": "Void",
  "exp.badge.overdue": "Overdue",

  "exp.col.date": "Date",
  "exp.col.vendor": "Vendor",
  "exp.col.description": "Description",
  "exp.col.bill": "Bill number",
  "exp.col.departments": "Departments",
  "exp.col.total": "Total",
  "exp.col.status": "Status",
  "exp.col.type": "Type",
  "exp.col.due": "Due",
  "exp.col.actions": "Actions",
  "exp.noDepartment": "No department",

  "exp.form.addExpense": "Add expense",
  "exp.form.addBill": "Add vendor bill",
  "exp.form.editExpense": "Edit expense",
  "exp.form.editBill": "Edit vendor bill",
  "exp.form.expenseBody": "An expense that has already been paid. Choose when and how it was paid.",
  "exp.form.billBody": "A bill from a vendor. It is saved as unpaid; pay it later from its page.",
  "exp.form.date": "Date",
  "exp.form.billDate": "Bill date",
  "exp.form.vendor": "Vendor",
  "exp.form.noVendor": "No vendor",
  "exp.form.chooseVendor": "Choose a vendor",
  "exp.form.billNumber": "Bill number",
  "exp.form.dueDate": "Due date",
  "exp.form.description": "Description",
  "exp.form.paidOn": "Paid on",
  "exp.form.method": "Payment method",
  "exp.form.reference": "Payment reference",
  "exp.form.referenceHint": "A check or receipt number. Never a card number.",
  "exp.form.receipt": "Receipt reference",
  "exp.form.receiptHint": "Where the receipt is kept, such as a file name or a link. Nothing is uploaded.",
  "exp.form.notes": "Notes",
  "exp.form.createExpense": "Record expense",
  "exp.form.createBill": "Save bill",
  "exp.form.saved": "Saved {description}.",
  "exp.form.recorded": "Recorded {description}.",
  "exp.method.check": "Check",
  "exp.method.cash": "Cash",
  "exp.method.card": "Card",
  "exp.method.ach": "Bank transfer (ACH)",
  "exp.method.other": "Other",

  "exp.lines.title": "Lines",
  "exp.lines.line": "Line {n}",
  "exp.lines.category": "Category",
  "exp.lines.chooseCategory": "Choose a category",
  "exp.lines.department": "Department",
  "exp.lines.categoryDefault": "Category's department",
  "exp.lines.categoryDefaultNamed": "{name} (the category's)",
  "exp.lines.description": "Line description",
  "exp.lines.amount": "Amount",
  "exp.lines.tax": "Tax",
  "exp.lines.add": "Add line",
  "exp.lines.remove": "Remove line {n}",
  "exp.lines.total": "Total",
  "exp.lines.noCategories": "There are no expense categories yet. Add one under Categories first.",
  "exp.lines.negativeNote": "A negative amount is a discount or credit.",
  "exp.lines.totalMustBePositive": "The lines must add up to more than zero.",

  "exp.validation.descriptionRequired": "Say what this was for.",
  "exp.validation.dateRequired": "Choose a date.",
  "exp.validation.vendorRequired": "A vendor bill needs a vendor.",
  "exp.validation.paidOnRequired": "Say when it was paid.",

  "exp.detail.title": "{description}",
  "exp.detail.about": "Details",
  "exp.detail.lines": "Lines",
  "exp.detail.vendor": "Vendor",
  "exp.detail.billNumber": "Bill number",
  "exp.detail.date": "Date",
  "exp.detail.due": "Due",
  "exp.detail.paidOn": "Paid on",
  "exp.detail.method": "Method",
  "exp.detail.reference": "Reference",
  "exp.detail.receipt": "Receipt",
  "exp.detail.notes": "Notes",
  "exp.detail.voidReason": "Void reason",
  "exp.detail.created": "Recorded",
  "exp.detail.voidNote": "This entry is void. It stays on record but is left out of every total and cannot be changed.",
  "exp.detail.historyNote": "Imported history is read-only. Corrections come from the history import.",
  "exp.detail.total": "Total",
  "exp.detail.notFound": "That entry could not be found.",
  "exp.action.pay": "Pay",
  "exp.action.unpay": "Mark unpaid",
  "exp.action.void": "Void",
  "exp.pay.title": "Pay {description}",
  "exp.pay.body": "Record how this was paid. The total is {total}.",
  "exp.pay.paidOn": "Paid on",
  "exp.pay.method": "Method",
  "exp.pay.reference": "Reference",
  "exp.pay.submit": "Record payment",
  "exp.pay.done": "Recorded the payment of {description}.",
  "exp.unpay.title": "Mark as unpaid",
  "exp.unpay.body": "The payment details are cleared and the entry goes back to unpaid. Say why.",
  "exp.unpay.submit": "Mark unpaid",
  "exp.unpay.done": "{description} is unpaid again.",
  "exp.void.title": "Void this entry",
  "exp.void.body": "A voided entry stays on record but no longer counts in any total. This cannot be undone. Say why.",
  "exp.void.submit": "Void",
  "exp.void.done": "Voided {description}.",
  "exp.reason.label": "Reason",
  "exp.reason.hint": "At least 3 characters.",
  "exp.reason.tooShort": "Give a reason of at least 3 characters.",

  "exp.vendors.title": "Vendors",
  "exp.vendors.subtitle": "The people and companies the club buys from.",
  "exp.vendors.add": "Add vendor",
  "exp.vendors.edit": "Edit vendor",
  "exp.vendors.editNamed": "Edit {name}",
  "exp.vendors.empty": "No vendors yet",
  "exp.vendors.emptyBody": "Add the first vendor to record bills against it.",
  "exp.vendors.noMatch": "No vendor matches",
  "exp.vendors.show": "Show",
  "exp.vendors.showActive": "Active vendors",
  "exp.vendors.showInactive": "Inactive vendors",
  "exp.vendors.showAll": "All vendors",
  "exp.vendors.created": "Added {name}.",
  "exp.vendors.updated": "Saved {name}.",
  "exp.vendor.name": "Name",
  "exp.vendor.code": "Code",
  "exp.vendor.contact": "Contact",
  "exp.vendor.email": "Email",
  "exp.vendor.phone": "Phone",
  "exp.vendor.address": "Address",
  "exp.vendor.notes": "Notes",
  "exp.vendor.active": "Active",
  "exp.vendor.activeHint": "Inactive vendors stay on old bills but are not offered for new ones.",
  "exp.vendor.inactive": "Inactive",
  "exp.vendor.create": "Add vendor",
  "exp.vendor.about": "Vendor details",
  "exp.vendor.bills": "Bills and expenses",
  "exp.vendor.noBills": "Nothing has been recorded for this vendor",
  "exp.vendor.noBillsBody": "Bills and expenses with this vendor appear here.",
  "exp.vendor.back": "Vendors",
  "exp.vendor.addBill": "Add bill",

  "exp.categories.title": "Expense categories",
  "exp.categories.subtitle": "Each category posts to an expense account and can default to a department.",
  "exp.categories.add": "Add category",
  "exp.categories.edit": "Edit category",
  "exp.categories.editNamed": "Edit {name}",
  "exp.categories.empty": "No expense categories yet",
  "exp.categories.emptyBody": "Add categories such as Food purchases or Utilities, then record expenses against them.",
  "exp.categories.readOnly": "Changing categories needs the billing settings permission.",
  "exp.categories.created": "Added {name}.",
  "exp.categories.updated": "Saved {name}.",
  "exp.categories.name": "Name",
  "exp.categories.code": "Code",
  "exp.categories.account": "Expense account",
  "exp.categories.chooseAccount": "Choose an account",
  "exp.categories.department": "Default department",
  "exp.categories.noDepartment": "No default department",
  "exp.categories.active": "Active",
  "exp.categories.inactive": "Inactive",
  "exp.categories.create": "Add category",
  "exp.categories.lookupFailed": "The chart of accounts could not be read, so categories cannot be edited here.",

  "exp.income.title": "Other income",
  "exp.income.subtitle": "Income that did not come through a member account, such as rentals or interest.",
  "exp.income.add": "Add other income",
  "exp.income.empty": "No other income yet",
  "exp.income.emptyBody": "Record income here and it appears in the department profit and loss.",
  "exp.income.noMatch": "Nothing matches these filters",
  "exp.income.date": "Date",
  "exp.income.department": "Department",
  "exp.income.account": "Revenue account",
  "exp.income.chooseAccount": "Choose an account",
  "exp.income.noDepartment": "No department",
  "exp.income.description": "Description",
  "exp.income.amount": "Amount",
  "exp.income.reference": "Reference",
  "exp.income.referenceHint": "A check or receipt number. Never a card number.",
  "exp.income.status": "Status",
  "exp.income.active": "Counted",
  "exp.income.void": "Void",
  "exp.income.create": "Record income",
  "exp.income.created": "Recorded {description}.",
  "exp.income.voidTitle": "Void this income",
  "exp.income.voidBody": "A voided entry stays on record but no longer counts in any total. Say why.",
  "exp.income.voidSubmit": "Void income",
  "exp.income.voided": "Voided {description}.",
  "exp.income.voidAction": "Void {description}",
  "exp.income.voidReason": "Void reason",
  "exp.income.amountPositive": "The amount must be more than zero.",

  "exp.reports.title": "Finance reports",
  "exp.reports.subtitle": "Profit and loss, receivables, spending and the accountant's export.",
  "exp.reports.nav": "Reports",
  "exp.reports.back": "Reports",
  "exp.reports.open": "Open report",
  "exp.reports.pnl": "Department profit and loss",
  "exp.reports.pnlBody": "Revenue, other income and expenses for each department over a period.",
  "exp.reports.spending": "Member spending",
  "exp.reports.spendingBody": "What one household or member was charged, by department, member or month.",
  "exp.reports.aging": "Receivables aging",
  "exp.reports.agingBody": "Who owes the club, by how long it has been owed.",
  "exp.reports.revenue": "Revenue by department and item",
  "exp.reports.revenueBody": "Sales with discounts, tax, service charge and gratuity.",
  "exp.reports.journal": "Daily posting journal",
  "exp.reports.journalBody": "Everything posted on a day or over a period, with totals by kind.",
  "exp.reports.reconciliation": "Ledger reconciliation",
  "exp.reports.reconciliationBody": "Proves the ledger adds up and matches every account's balance.",
  "exp.reports.export": "Accountant export",
  "exp.reports.exportBody": "Download the postings and the expenses of a period as CSV files.",

  "exp.range.from": "From",
  "exp.range.to": "To",
  "exp.range.asOf": "As of",
  "exp.range.thisMonth": "This month",
  "exp.range.lastMonth": "Last month",
  "exp.range.yearToDate": "Year to date",
  "exp.range.presets": "Quick periods",
  "exp.range.invalid": "The start date must not be after the end date.",
  "exp.range.required": "Choose both dates.",
  "exp.report.updating": "Updating the report…",
  "exp.report.total": "Total",
  "exp.report.count": "{count} shown",

  "exp.pnl.title": "Department profit and loss",
  "exp.pnl.subtitle": "Revenue and other income less expenses, by department.",
  "exp.pnl.detail": "Show the accounts behind each department",
  "exp.pnl.department": "Department",
  "exp.pnl.revenue": "Revenue",
  "exp.pnl.otherIncome": "Other income",
  "exp.pnl.expenses": "Expenses",
  "exp.pnl.net": "Net",
  "exp.pnl.total": "Total",
  "exp.pnl.unassigned": "Unassigned",
  "exp.pnl.unassignedHint": "Amounts that have no department.",
  "exp.pnl.loss": "Loss",
  "exp.pnl.empty": "Nothing was recorded in this period",
  "exp.pnl.emptyBody": "There are no charges, other income or expenses between these dates.",
  "exp.pnl.period": "{from} to {to}",
  "exp.pnl.kind.revenue": "Revenue",
  "exp.pnl.kind.other_income": "Other income",
  "exp.pnl.kind.expense": "Expense",
  "exp.pnl.accounts": "Accounts of {name}",

  "exp.spending.title": "Member spending",
  "exp.spending.subtitle": "What the whole club, a household or a member was charged. Dues and balances brought forward are not spending.",
  "exp.spending.lookup": "Look up by",
  "exp.spending.club": "Whole club",
  "exp.spending.household": "Household",
  "exp.spending.member": "Member",
  "exp.spending.searchHousehold": "Find a household",
  "exp.spending.searchMember": "Find a member",
  "exp.spending.searchHint": "Type a name or number, then choose one.",
  "exp.spending.noResults": "Nobody matches that.",
  "exp.spending.chosen": "Showing {name}",
  "exp.spending.change": "Choose someone else",
  "exp.spending.groupBy": "Group by",
  "exp.spending.byDepartment": "Department",
  "exp.spending.byHousehold": "Household",
  "exp.spending.byMember": "Member",
  "exp.spending.byMonth": "Month",
  "exp.spending.choose": "Choose a household or member",
  "exp.spending.chooseBody": "Search above, pick one, and the report appears.",
  "exp.spending.empty": "No charges in this period",
  "exp.spending.emptyBody": "This account was not charged anything between these dates.",
  "exp.spending.group": "Group",
  "exp.spending.items": "Items",
  "exp.spending.tax": "Tax",
  "exp.spending.service": "Service charge",
  "exp.spending.gratuity": "Gratuity",
  "exp.spending.total": "Total",
  "exp.spending.ledgerEmpty": "No charges have been posted yet",
  "exp.spending.ledgerEmptyBody": "No charges have been posted in ClubCore yet. Spending appears here once the Jonas spending history is imported.",
  "exp.spending.truncated": "Showing the top {shown} of {count}. The total row covers all {count}.",
  "exp.spending.memberNeedsAccess": "Searching members needs the members permission.",

  "exp.aging.title": "Receivables aging",
  "exp.aging.subtitle": "Accounts with a balance, by how long it has been owed.",
  "exp.aging.search": "Search accounts",
  "exp.aging.minBalance": "Minimum balance",
  "exp.aging.overdueOnly": "Overdue only",
  "exp.aging.overdueOnlyHint": "Leave out accounts whose whole balance is current.",
  "exp.aging.account": "Account",
  "exp.aging.name": "Household",
  "exp.aging.current": "Current",
  "exp.aging.d30": "30 days",
  "exp.aging.d60": "60 days",
  "exp.aging.d90": "90 days",
  "exp.aging.d120": "120+ days",
  "exp.aging.balance": "Balance",
  "exp.aging.empty": "No accounts owe anything",
  "exp.aging.emptyBody": "No account has a balance on this date with these filters.",
  "exp.aging.totals": "Totals on {date}",
  "exp.aging.accounts": "Accounts",
  "exp.aging.owing": "Owed to the club",
  "exp.aging.credits": "Credits held",
  "exp.aging.open": "Open account {name}",

  "exp.revenue.title": "Revenue by department and item",
  "exp.revenue.subtitle": "Net sales with the discounts, tax, service charge and gratuity collected over the same dates.",
  "exp.revenue.groupBy": "Group by",
  "exp.revenue.byDepartment": "Department",
  "exp.revenue.byItem": "Item",
  "exp.revenue.department": "Department",
  "exp.revenue.anyDepartment": "All departments",
  "exp.revenue.code": "Code",
  "exp.revenue.name": "Name",
  "exp.revenue.quantity": "Quantity",
  "exp.revenue.count": "Sales",
  "exp.revenue.gross": "Gross",
  "exp.revenue.discounts": "Discounts",
  "exp.revenue.net": "Net",
  "exp.revenue.tax": "Tax",
  "exp.revenue.service": "Service charge",
  "exp.revenue.gratuity": "Gratuity",
  "exp.revenue.unassigned": "Without a department",
  "exp.revenue.empty": "No sales in this period",
  "exp.revenue.emptyBody": "Nothing was sold between these dates with these filters.",
  "exp.revenue.totals": "Totals for the period",

  "exp.journal.title": "Daily posting journal",
  "exp.journal.subtitle": "Everything posted on a day or over a period, oldest first.",
  "exp.journal.kind": "Kind",
  "exp.journal.anyKind": "Any kind",
  "exp.journal.department": "Department",
  "exp.journal.source": "Source module",
  "exp.journal.postedBy": "Posted by",
  "exp.journal.search": "Search descriptions",
  "exp.journal.number": "No.",
  "exp.journal.date": "Date",
  "exp.journal.account": "Account",
  "exp.journal.household": "Household",
  "exp.journal.description": "Description",
  "exp.journal.member": "Member",
  "exp.journal.sourceCol": "Source",
  "exp.journal.postedByCol": "Posted by",
  "exp.journal.total": "Total",
  "exp.journal.empty": "Nothing was posted",
  "exp.journal.emptyBody": "No postings match these dates and filters.",
  "exp.journal.totals": "Totals by kind",
  "exp.journal.totalsLine": "{count} postings",
  "exp.journal.open": "Open account {name}",
  "exp.journal.kind.charge": "Charge",
  "exp.journal.kind.dues": "Dues",
  "exp.journal.kind.payment": "Payment",
  "exp.journal.kind.credit": "Credit",
  "exp.journal.kind.adjustment": "Adjustment",
  "exp.journal.kind.writeoff": "Write-off",
  "exp.journal.kind.opening": "Opening balance",
  "exp.journal.kind.interest": "Interest",
  "exp.journal.kind.minimum": "Minimum",
  "exp.journal.relation.reversal": "Reversal",
  "exp.journal.relation.refund": "Refund",

  "exp.recon.title": "Ledger reconciliation",
  "exp.recon.subtitle": "The ledger checked against itself.",
  "exp.recon.run": "Check again",
  "exp.recon.ok": "The ledger is in balance",
  "exp.recon.okBody": "Every posting adds up to zero, every header total matches its lines, and the account balances add up to the whole.",
  "exp.recon.bad": "The ledger does not reconcile",
  "exp.recon.badBody": "Something does not add up. The figures below show where. Do not post corrections until you know the cause.",
  "exp.recon.transactions": "Postings",
  "exp.recon.lines": "Ledger lines",
  "exp.recon.linesSum": "Sum of all lines",
  "exp.recon.receivable": "Receivable lines",
  "exp.recon.txTotals": "Sum of posting totals",
  "exp.recon.unbalanced": "Unbalanced postings",
  "exp.recon.mismatched": "Postings whose total differs from its lines",
  "exp.recon.households": "Accounts with a balance",
  "exp.recon.balances": "Sum of account balances",
  "exp.recon.problem": "Needs attention",

  "exp.export.title": "Accountant export",
  "exp.export.subtitle": "CSV files for the accountant, for a period of up to five years.",
  "exp.export.period": "Period",
  "exp.export.postings": "Postings (CSV)",
  "exp.export.postingsBody": "One row per ledger line, debits and credits in separate columns.",
  "exp.export.expenses": "Expenses (CSV)",
  "exp.export.expensesBody": "One row per expense line. Voided expenses are left out.",
  "exp.export.download": "Download",
  "exp.export.downloading": "Preparing the file…",
  "exp.export.done": "Downloaded {file}.",

  "apiError.duplicate_bill": "That vendor already has a bill with that number.",
  "apiError.expense_void": "A voided expense cannot be changed.",
  "apiError.total_not_positive": "The lines must add up to more than zero.",
  "apiError.card_number_refused": "That looks like a card number. Record the check number or receipt number, never the card number.",
  "apiError.vendor_required": "A vendor bill needs a vendor.",
  "apiError.payment_required": "An expense that is already paid needs the date and method it was paid.",
  "apiError.bill_created_unpaid": "A bill is saved unpaid. Record the payment afterwards.",
  "apiError.already_paid": "This is already paid.",
  "apiError.not_paid": "This is not paid.",
  "apiError.vendor_name_taken": "A vendor with that name already exists.",
  "apiError.vendor_not_found": "That vendor no longer exists.",
  "apiError.expense_category_code_taken": "An expense category with that code already exists.",
  "apiError.account_not_expense": "An expense category must use an expense account.",
  "apiError.account_not_revenue": "Other income must use a revenue account.",
  "apiError.account_not_found": "That account no longer exists.",
  "apiError.department_not_found": "That department no longer exists.",
  "apiError.expense_not_found": "That expense no longer exists.",
  "apiError.income_not_found": "That income entry no longer exists.",
  "apiError.income_void": "Voided income cannot be changed.",
  "apiError.reason_required": "Give a reason of at least 3 characters.",
  "apiError.invalid_range": "The start date must not be after the end date.",
  "apiError.range_too_long": "Choose a period of at most five years.",
  "apiError.scope_required": "Choose a household or a member.",
  "apiError.invalid_group": "That grouping is not available.",
} as const;
export type ExpensesMessages = typeof expensesEn;
